/**
 * Smatchy
 * The smatchy API description. Use POST /auth/login to get an access token.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PayoutRequestHistoryItemDto { 
    /**
     * History record ID
     */
    id: string;
    /**
     * Parent payout request ID
     */
    payoutRequestId: string;
    /**
     * Organizer ID
     */
    organizerId: string;
    /**
     * Amount in cents
     */
    amount: number;
    /**
     * Payout state at this snapshot
     */
    status: PayoutRequestHistoryItemDto.StatusEnum;
    /**
     * Request timestamp
     */
    requestedAt: string;
    /**
     * Approval timestamp
     */
    approvedAt?: string;
    /**
     * Approved by user ID
     */
    approvedBy?: string;
    /**
     * Processed timestamp
     */
    processedAt?: string;
    /**
     * Paid timestamp
     */
    paidAt?: string;
    /**
     * Stripe payout ID
     */
    stripePayoutId?: string;
    /**
     * Failure reason
     */
    failureReason?: string;
    /**
     * Snapshot timestamp (when this record was created)
     */
    createdAt: string;
}
export namespace PayoutRequestHistoryItemDto {
    export type StatusEnum = 'pending' | 'approved' | 'in_transit' | 'paid' | 'declined' | 'failed' | 'canceled';
    export const StatusEnum = {
        Pending: 'pending' as StatusEnum,
        Approved: 'approved' as StatusEnum,
        InTransit: 'in_transit' as StatusEnum,
        Paid: 'paid' as StatusEnum,
        Declined: 'declined' as StatusEnum,
        Failed: 'failed' as StatusEnum,
        Canceled: 'canceled' as StatusEnum
    };
}


